export default __webpack_public_path__ + "static/media/david_cruwys.5bd283ce.png";